import { apiClient } from "../config/api.client";
import { ALL_GAMES, ALL_PRODUCTS, CREATE_GAME, CREATE_PRODUCT, PORDUCT_BY_ID } from "../constants/api.constant";

export const getAllGames = async () => {
    try {
        const { data } = await apiClient.get(ALL_GAMES);
        return data;
    } catch (error) {
        console.log("Error Fetching All Games :", error);
        throw error;
    }
}



export const createGame = async (name, publisher, image, validationFields) => {
    try {
        const { data } = await apiClient.post(
            CREATE_GAME,
            {
                name,
                publisher,
                image,
                validationFields
            },
            { headers: { "Content-Type": "application/json" }}
        );
        return data;
    } catch (error) {
        console.log("Error Creating Game :", error);
        throw error;
    }
}

export const createProduct = async (gameId, amount, commission, cashback, logo, description, status, apiMappings) => {
    try {
        const { data } = await apiClient.post(
            CREATE_PRODUCT(gameId),
            {
                amount,
                commission,
                cashback,
                logo,
                description,
                status,
                apiMappings
            },
            { headers: { "Content-Type": "application/json" }}
        );
        return data;
    } catch (error) {
        console.log("Error Creating Product :", error);
        throw error;
    }
}

export const getAllProduct = async (gameId) => {
    try {
        const { data } = await apiClient.get(ALL_PRODUCTS(gameId));
        return data;
    } catch (error) {
        console.log("Error Fetching All Products :", error);
        throw error;
    }
}

export const getProductById = async (productId) => {
    try {
        const { data } = await apiClient.get(PORDUCT_BY_ID(productId));
        return data;
    } catch (error) {
        console.log("Error Fetching Product :", error);
        throw error;
    }
}
